// extracted by mini-css-extract-plugin
module.exports = {"comments":"page_comments__DDOeA"};